import React from 'react';
import cx from 'classnames';
import { Grid, Row, Col, Image } from 'react-bootstrap';
import { browserHistory } from 'react-router';
import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';
import Text from 'src/components/text';
class DeleteUserGroupView extends React.Component {
  constructor(props) {
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedNewGroup = this.localizedUserManagement.create_new_group;
  }

  _handleDeleteClick() {
    var index = this.props.userGroups.findIndex((userGroup) => {
      return userGroup.id == this.props.userGroup.id;
    })

    this.props.deleteUserGroup(this.props.userGroup.id).then(() => {
      if (this.props.onDeletion) {
        this.props.onDeletion();
      } 

      var nextIndex = 0;

      if (index > 0) {
        var nextIndex = index++;

        if (nextIndex > this.props.userGroups.length - 1) {
          nextIndex = this.props.userGroups.length - 1;
        }
      }

      var nextUserGroup = this.props.userGroups[nextIndex];
      if (nextUserGroup) {
        this.props.navigate(`/settings/user-management/group/${nextUserGroup.id}`);

      } else {
        this.props.navigate(`/settings/user-management/group`);
      }
    });
  }

  _handleCancelClick() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row className={styles.top}>
          <Col sm={8} className={styles.column}>
            <div className={styles.heading}>{this.localizedNewGroup.delete.title}</div>
            <div className={styles.label}>
              1 {this.localizedCommons.user_group}
                </div>

            <p className={styles.description}>
              {this.localizedNewGroup.delete.confirmation}
                </p>
          </Col>
          <Col sm={12} className={styles.column}>
            <div className={styles.contacts}>
              {this.props.userGroup &&
                <div className={cx(styles.userGroupRow, styles.active)}>
                    <div className={styles.iconContainer}>
                      <div className={styles.contactAvatar}> {this.renderInitials(this.props.userGroup)} </div>
                    </div>
                  <Row className={styles.metadata}>
                    <Col md={12} className={styles.groupName}>
                      <Text text={this.props.userGroup.name} lines={1} tooltip={{placement: "auto"}} />
                    </Col>
                    <Col md={12} className={styles.usersCount}>
                      {`${this.props.userGroup.users.length || 0} ${this.localizedCommons.users}`}
                    </Col>
                  </Row>
                </div>
              }
            </div>
          </Col>
        </Row>
        <div className={styles.buttonTray}>
          <Button
            text={this.props.deleting ? `${this.localizedCommonActions.deleting}` : this.localizedCommonActions.confirm}
            disabled={this.props.deleting}
            variant='primary'
            className={styles.send}
            onClick={() => { this._handleDeleteClick() }}
            icon='paperflite-tick'
          >
          </Button>
          <Button
            text={this.localizedCommonActions.cancel}
            disabled={this.props.deleting}
            variant='secondary'
            className={styles.cancel}
            onClick={() => { this._handleCancelClick() }}
          >
          </Button>
        </div>
      </div>
    );
  }

  renderInitials(userGroup) {
    let initial = '';

    if (userGroup.name) {
      initial = userGroup.name.charAt(0);
    }

    return initial.toUpperCase();
  }
}
export default DeleteUserGroupView;